import fetch from './';
import { Context } from 'features/app/types';
import { SubjectAreaGraphData, SubjectAreaGridData } from 'features/subjectArea/types/common';

export type SubjectAreaAttainmentProfileDataResponse = {
	grid: SubjectAreaGridData.GridData<SubjectAreaGridData.ResponseRow> & {
		comparisons?: SubjectAreaGridData.Comparisons<SubjectAreaGridData.ResponseRow>;
	};
	graph: SubjectAreaGraphData.GraphData<SubjectAreaGraphData.ResponseXAxisValues> & {
		comparisons?: SubjectAreaGraphData.Comparisons<SubjectAreaGraphData.ResponseXAxisValues>;
	};
};

//TODO: If the subject pages are ever redone id like to circle back to this and get area working properly
/**
 * Get the main grid and graph data for the given area and exam level
 * @param area string,
 * @param examLevel number,
 * @param benchmark string,
 * @param gradepoints Context.Gradepoint[],
 */
export const fetchAttainmentProfileData = (
	area: string,
	examLevel: number,
	benchmarkSet: string,
	gradepoints: Context.Gradepoint[],
	subjectId: number[],
	udf: { type: string; value: string },
	comparisons?: Context.ReportAppliedComparisons[],
	versionNumber: number = 2
): Promise<ResponseBuilder<SubjectAreaAttainmentProfileDataResponse>> => {
	void area;

	const body = {
		BenchmarkSet: benchmarkSet,
		GradePoints: gradepoints,
		ExamLevel: examLevel,
		SubjectId: subjectId,
		...(comparisons ? { AppliedComparisons: comparisons } : {}),
		Teacher: formatUdfValuesForBigfoot(udf, 'Teacher'),
		TeachingSet: formatUdfValuesForBigfoot(udf, 'Teaching Set'),
	};

	return fetch(
		`/bigfoot/v${versionNumber}/SubjectArea/AttainmentProfile/GetSubjectPageAttainmentProfileData`,
		{
			method: 'POST',
			body,
		},
		true
	);
};

//#region Private methods

/**
 * Format the udf value into a string or undefined
 * @param udf teacher or teaching set value
 * @param wantedType which value is needed
 * @returns
 */
const formatUdfValuesForBigfoot = (
	udf: { type: string; value: string },
	wantedType: string
): string | undefined => {
	if (udf.value.length === 0) {
		return undefined;
	} else if (udf.type === wantedType) {
		return udf.value;
	} else {
		return undefined;
	}
};

//#endregion
